import React, { useEffect, useContext, useState } from "react"
import { SectionContext } from "../context/sectionContext"
import { ConditionContext } from "../context/conditionContext"
import { JourneyContext } from "../context/journeyContext"
import "swiper/swiper.min.css"
import "swiper/components/navigation/navigation.min.css"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import { lineCapital } from "../../shared/functions"
import { productRenderChecker, getValueFromJourney, isEquitasChannel } from "../services/helperFunctions"
import { componentRenderCheck, multiConditionComponentRenderCheck } from "../services/componentRenderCheck"
import Parser from 'html-react-parser';

export default function ComponentCheckboxSingleFormGroup(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [options, setOptions] = useState({})

  const handleEnter = (event1,event2) =>{
    handleChange(event1)

  }

  const handleChange = (ev) => {
    console.log(ev.target.value, "target in checkbox single fg")
    if (sectionState.sectionId === props.sectionId) {
      if(sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey] === ev.target.value ){
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: "",
            },
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
          }
        })
      }else{
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: ev.target.value,
            },
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: ev.target.value,
          }
        })
      }
    } else {
      if(sectionState.sectionData && sectionState.sectionData[props.data.formControlKey] === ev.target.value){
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: "",
            },
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "",
          }
        })
      }else{
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: ev.target.value,
            },
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: ev.target.value,
          }
        })
      }
      
    }
    
  }

  let optionsToShow = []

  props.data.CBM?.forEach(element => {
    if(element?.conditions?.data?.length){
      if (element?.conditions?.data?.length === 1) {
        if (componentRenderCheck(element.conditions?.data[0]?.attributes, conditionState[element.conditions?.data[0]?.attributes?.watchKey], journeyState)) {
          optionsToShow.push(element)
        } 
      } else if (element?.conditions?.data?.length > 1) {
        if (multiConditionComponentRenderCheck(element.conditions?.data, conditionState, journeyState)) {
          optionsToShow.push(element)
        }
      }
    }else{
      optionsToShow.push(element)
    }
  })

  return (optionsToShow.length ?
    <div className={`field ${props.class}`} key={props.sectionId + props.indexForKey}>
      <style>
        {`
        .radio-tab {
          display: flex;
          justify-content:space-evenly;
          margin-bottom:2rem;
          border:1px solid black;
        }
        .radio-tab > *{
          color:black;
          background:transparent;
          padding:0;
          flex:1;
          padding: 4px 0;

        }

        .radio-tab p{
          margin:0;
          
        }

        .active-tab{
          background-color: ${props.channel === "A" ? "#000000" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"};
          background-color: var(--lumiq-secondary);
          color:white
        }
        .card-label {
          height:3rem;
          text-align:center;
          font-weight:bold;
        }

        
        .tick{
          position:relative;
          top:5rem;
          left:2rem;
          z-index:1;
        }
        
        @media screen and (max-width:767px){
          .tick{
            top: 44px;
            left: 11px;
          }
        }

        
        .check11{
          display:none !important ;
        }
        .left-addon input[type="checkbox"].css-checkbox:checked + label.css-label,
        input[type="radio"].css-checkbox:checked + label.css-label {
          background-position: 0 -43px;
        }
        `}
      </style>
      <div 
       className={`form-group ${props.data.disabled ? "disable-input" : ""}`}
       >
         <label className="input-radio-section-design">
         <p>{(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}{isEquitasChannel(props.channel) && props.data.required && <span className="equitas-required-marker"> *</span>}</p>
        </label>
        <div className="row">
        {optionsToShow?.map((element, i) => {
          return (
            <div className={`field ${element.class}`}>
              <div className={`checkbox-container `}>
                <div className="inner-addon left-addon">
                  <div className="checkbox1">
                    <input
                      id={element.value}
                      className={`css-checkbox form-control`}
                      type="checkbox"
                      name={element.name}
                      value={element.value}
                      onChange={handleChange}
                      checked={sectionState.sectionData 
                        && sectionState.sectionData[props.data.formControlKey] === element.value
                      }
                    />

                    <label
                      htmlFor={element.value}
                      className="css-label"
                    >
                      <span style={{ display: "flex" }}>
                        <span style={{ display: "block" }}>
                          <span className="radiotextsty inp-label">{(getValueFromJourney(
                            journeyState.lookup.label,
                            element.label
                          )) || element.label}</span>
                        </span>
                        {element.tooltip &&
                          <span style={{ marginLeft: "10px" }} className="tooltip-col text-tool-tip-design existing-tool-tip">
                            <div className="tool">i</div>
                            <span className="tooltiptext4 tooltiptext5 tooltiptext4-align-list " style={{ width: "22rem", height: "fit-content", top: "auto", pointerEvents: "none" }}>
                              {Parser((getValueFromJourney(
                                journeyState.lookup.tooltip,
                                element.tooltip
                              )))}
                            </span>
                          </span>
                        }
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
        </div>
      </div>
    </div>
    :
    <>
    </>
  )
}
